export enum FISCALIZATION_STATUSES_ENUM {
    RECEIPT = "b7d135c5-3960-4b4f-850d-1fd183cd274f",
    REFUND = "dbc66079-4468-4df1-a8db-719bde7c4bf0",
}
